import { UserAvatar } from "components/Atoms/Avatar";
import ListTemplate from "components/ListTemplate";
import { LastRefreshDotLabel } from "externalCalendar/LastRefreshDotLabel";
import React from "react";
import { useLoaderData } from "react-router";
import { routes } from "utilities/routing/generatedRoutes";
import Filters from "./Filters";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";

const getCalendarTypeName = (type: server.dto.ExternalCalendarTypes) => {
  switch (type) {
    case "googleCalendar":
      return "Google Calendar";
    case "iCalendar":
      return "external ICalendar";
    default:
      return "";
  }
}

const ExternalCalendarName = ({ item }: { item: server.dto.ExternalCalendarForList }) =>
  <div>
    <a href={routes.externalCalendar_Detail(item.externalCalendarId).absolute}>{item.artist.name}</a>
    <LastRefreshDotLabel item={item} />
  </div>

const ExternalCalendarList = () => {
  const viewModel = useLoaderData<server.viewmodel.ExternalCalendarListFrontModel>();

  return <ListTemplate
    perPage={50}
    title={RESX.ExternalCalendar.resxExternalCalendar}
    filterSet="externalCalendar_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.ExternalCalendar.Paginated}
    getId={item => item.externalCalendarId}
    layout={{
      type: "table",
      columns: [{
        key: "artist",
        header: RESX.Artist.resxArtist,
        render: item => <ExternalCalendarName item={item} />,
      }, {
        key: "type",
        header: RESX.GeneralLabels.Type,
        render: item => <div>
          <div>{getCalendarTypeName(item.type)}</div>
          <div className="s1_gray">{item.title}</div>
        </div>,
      }, {
        key: "createdBy",
        header: RESX.RecordInformation.CreatedBy,
        render: item => <UserAvatar user={item.createdBy} />,
      }, {
        key: "events",
        header: "Events",
        render: item => item.eventCount,
        size: "fit-content(60px)",
        className: "s1_cell_financialamount"
      }],
    }}
    filters={<Filters />}
    functions={{
      mapResponseToFilterValues,
      mapFilterValuesToInstruction
    }}
  />
}

export default ExternalCalendarList;